<template>
    <drawer-layout>
        <div class="report-container mx-7 mt-4">
            <report-header :type="reportType"/>

            <reports-table :type="reportType"/>
        </div>

        <div class="report-container mx-7 mt-4" v-if="isStatisticalReport">
            <report-header :type="reportType"/>

            <reports-table :type="reportType"/>
        </div>

        <v-card flat v-else>
            <v-card-title>
                <v-icon large left>mdi-wrench-clock</v-icon>
                <span class="text-h6">Trabajo en progreso {{ reportType.title }}</span>
            </v-card-title>
        </v-card>

    </drawer-layout>
</template>

<script>
import DrawerLayout from "@/Shared/DrawerLayout";
import ReportHeader from "@/Shared/Reports/Index/ReportHeader";
import {mapActions} from 'pinia';
import {ReportsStore} from "@/Store/Reports/ReportsStore";
import ReportsTable from "@/Shared/Reports/Index/ReportsTable";
import _ from "lodash";

export default {
    name: "Index",

    components: {DrawerLayout, ReportHeader, ReportsTable},

    props: {
        reportType: {
            type: Object,
            default: [],
        },
        academicPeriods: {
            type: Object,
            required: true,
        }
    },

    created() {

    },

    data () {
        return {

        }
    },

    methods: {
        ...mapActions(ReportsStore, [
            'setAcademicPeriods',
        ]),
    },

    computed: {

        /**
         * TODO: delete it later, functional demo support
         * @returns {boolean}
         */
        isTableTwoReport() {
            return _.get(this.type, 'id') === 'table-2';
        },

        isStatisticalReport() {
            return _.get(this.type, 'id') === 'statistical-report';
        }
    },

    mounted() {
        this.setAcademicPeriods(_.get(this.academicPeriods, '_embedded.academic_periods'));
    }
}
</script>

<style scoped>

</style>
